import React from 'react';
import {
  Item,
  List,
  Grid
} from 'semantic-ui-react';


export const PicturesList = ({pictures}) => (
  <Item.Group>
    { pictures.map( (pic, ind) => (
      <Item key={ind}>
        <Item.Image size='medium' src={pic.picture} />
        <Item.Content>
          <Item.Header>{`Picture ${ind+1}`}</Item.Header>
          <Item.Meta>{`People: ${pic.people}`}</Item.Meta>
          <Item.Description>
            Description: {pic.description}
          </Item.Description>
        </Item.Content>
      </Item>
    )) }
  </Item.Group>
);

export const BookInfo = (props) => (
  <List size="large">
    <List.Item>
      <List.Icon name='users' />
      <List.Content>{props.name}</List.Content>
    </List.Item>
    <List.Item>
      <List.Icon name='mail' />
      <List.Content>{props.email}</List.Content>
    </List.Item>
    <List.Item>
      <List.Icon name='phone' />
      <List.Content>{props.telephone}</List.Content>
    </List.Item>
  </List>
);

export const BookDisplay = (props) => (
  <Grid>
    <Grid.Row>
      <BookInfo name={props.name} email={props.email} telephone={props.telephone} />
    </Grid.Row>
    <Grid.Row>
      <PicturesList pictures={props.pictures} />
    </Grid.Row>
  </Grid>
);

export default BookDisplay;
